export { default as AdminListTableHeadDesktop } from './AdminListTableHeadDesktop';

export type {
  AdminListTableHeadDesktopProps,
  AdminListTableHeadDesktopComponent,
} from './AdminListTableHeadDesktop.type';
